import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "onFocus", "onBlur", "maxRows", "value", "error", "style", "onChange"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef } from 'react';
import { cnBem, combineRefs } from '@carnica/utils';
import styles from "./styles.pcss";
import { useTextAreaSize } from "../hooks/useTextAreaSize";
var cnTextAreaCore = cnBem('textarea-core', styles);
export var TextAreaCore = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    onFocusProp = props.onFocus,
    onBlurProp = props.onBlur,
    maxRows = props.maxRows,
    value = props.value,
    error = props.error,
    style = props.style,
    onChangeProp = props.onChange,
    otherProps = _objectWithoutProperties(props, _excluded);
  var onFocus = function onFocus(e) {
    return onFocusProp === null || onFocusProp === void 0 ? void 0 : onFocusProp(value, e);
  };
  var onBlur = function onBlur(e) {
    return onBlurProp === null || onBlurProp === void 0 ? void 0 : onBlurProp(value, e);
  };
  var _useTextAreaSize = useTextAreaSize({
      maxRows: maxRows,
      onChange: onChangeProp,
      value: value
    }),
    onChange = _useTextAreaSize.onChange,
    textAreaRef = _useTextAreaSize.textAreaRef,
    inputHeight = _useTextAreaSize.inputHeight,
    rows = _useTextAreaSize.rows,
    overflowFlag = _useTextAreaSize.overflowFlag;
  return /*#__PURE__*/React.createElement("div", {
    className: cnTextAreaCore(),
    "data-t-id": "TextArea-TextAreaCore"
  }, /*#__PURE__*/React.createElement("textarea", _extends({
    className: cnTextAreaCore('field', {
      size: rows < 4 ? 'large' : 'medium',
      overflow: !overflowFlag,
      error: !!error
    }, [className]),
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    ref: combineRefs([ref, textAreaRef]),
    style: _objectSpread(_objectSpread({}, style), {}, _defineProperty({}, '--text-area-height', "".concat(inputHeight, "px"))),
    value: value
  }, otherProps)));
});